// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__1AKIv","container":"styles_container__2KhW1"};